import React, { Component } from 'react';
import { Common } from '../../core/common';
import { Log } from 'ng2-logger';
import Translator from '../../core/i18n';
import { Input as InputReact, Modal } from 'reactstrap';
import Input from '../../components/input/text/input-formik';

const T = Translator.create();
const _logger = Log.create('Home Box Messages');
let _common: Common;
export class TwoFactorMail extends Component<any> {
    timer: any;
    public state = {
        codeScreenStatus: false,
        isVerificationCodeConfirmed: false,
        timeLeft: 120,   // second
        twoFactorVerificationError: '',
    }
    public constructor(props: any) {
        super(props);
        _common = new Common();
        this.timer = null;
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    resetFunction = () => {
        this.props.resetErrorMessage()
    }

    componentDidUpdate(prevProps: any, prevState: any, snapshot?: any): void {
        if(this.props.formik.values.twoFactorVerificationError?.length > 0 ){
            this.setState({twoFactorVerificationError: this.props.formik.values.twoFactorVerificationError, timeLeft: 0}, this.resetFunction)
        }
    }

    emailButtonClicked = (status: boolean) => {
        this.setState({ codeScreenStatus: status });
        this.setState({ isVerificationCodeConfirmed: true })
        if (status)
        {
            this.startCountdown();
            this.props.sendVerificationCode(this.props.formik.values.twoFactorAuthMailAddress, true)
        }
    }

    callbackFunction = () => {
        if (!this.state.twoFactorVerificationError || this.state.twoFactorVerificationError.length === 0){
            this.props.formik.setFieldValue("twoFactorAuthMailAddress_checked", this.props.formik.values.twoFactorAuthMailAddress)
            this.props.onClickTwofactorModel(false)
        }
    }

    checkVerificationCode = () => {
        this.props.checkVerificationCode(this.props.formik.values.userName, this.props.formik.values.twoFactorCode, this.callbackFunction)
        this.props.resetErrorMessage()
    }


    resendVerificationCode = () => {
        this.setState({ timeLeft: 120, twoFactorVerificationError: '' }, this.startCountdown)
        this.props.sendVerificationCode(this.props.formik.values.twoFactorAuthMailAddress, true)
    };

    startCountdown = () => {
        this.timer = setInterval(() => {
            this.setState((prevState: any) => {
                if (prevState.timeLeft <= 0) {
                    clearInterval(this.timer);
                    return { timeLeft: 0 };
                }
                return { timeLeft: prevState.timeLeft - 1 };
            });
        }, 1000);
    };

    formatTime = (time: number) => {
        const minutes = Math.floor(time / 60);
        const seconds = time % 60;
        return `${minutes.toString().padStart(2, '0')}:${seconds
            .toString()
            .padStart(2, '0')}`;
    };

    public render() {

        const { timeLeft } = this.state;

        return (
            <Modal
                className="pt-0"
                style={{ maxWidth: '550px', margin: '0 auto', marginTop: "50px", height: "100%" }}
                isOpen={true}
                fade={true}
                backdrop={'static'}>
                <div className="white-box" style={{ padding: "15px", height: "100%" }}>
                    <div className="d-flex justify-content-between white-box-header">
                        <div>
                            <h2>
                                {T.t('r_add_two_factor_address_define')}
                            </h2>

                        </div>
                        <div className="align-self-center">

                            <a onMouseDown={event => this.props.onClickTwofactorModel(false)} >
                                <i className="material-icons ml-2 align-middle">close</i>
                            </a>
                        </div>
                    </div>
                    <div className="d-flex justify-content-between white-box-header" dangerouslySetInnerHTML={{ __html: T.t('r_add_two_factor_address_define_info') }}>
                    </div>
                    <div style={{ marginTop: "35px" }}>
                        {!this.state.codeScreenStatus ?
                            <Input
                                type={'text'}
                                name={'twoFactorAuthMailAddress'}
                                label={T.t('r_email_adress')}
                                formik={this.props.formik}
                            />
                            :
                            <div className='d-flex'>
                                <div className='col-md-1 d-flex justify-content-center' style={{ cursor: "pointer" }} onMouseDown={e => this.emailButtonClicked(false)}>
                                    <i className="material-icons">arrow_back_ios</i>

                                </div>
                                <div className='col-md-11'>
                                    <InputReact
                                        type={'text'}
                                        name={'twoFactorCode'}
                                        placeHolder={T.t('r_add_two_factor_code_enter')}
                                        style={{ borderTop: "0px", borderRight: "0px", borderLeft: "0px" }}
                                        formik={this.props.formik}
                                        onBlur={(e: any) => {
                                            const value = e.target.value;
                                            this.props.formik.setFieldValue('twoFactorCode', value);
                                        }}
                                        onClickCapture={() => this.setState({ twoFactorVerificationError: '' })}
                                    />
                                </div>

                            </div>
                        }

                    </div>
                    {(!this.props.formik.errors.email && !this.state.codeScreenStatus) ?
                        <div className='d-flex justify-content-center'> <button
                            onMouseDown={e => this.emailButtonClicked(true)}
                            className="success-btn "
                        >
                            {T.t('r_send_two_factor_code')}
                        </button></div>
                        :
                        <div
                            className="d-flex flex-column align-items-center"
                            style={{
                                marginTop: "40px",
                                paddingBottom: "10px",
                            }}
                        >
                            {this.state.twoFactorVerificationError?.length > 0 && (
                                <span style={{ color: "red", marginBottom: "10px" }}>
                                    {this.state.twoFactorVerificationError}
                                </span>
                            )}
                            <button
                                style={{
                                    backgroundColor: "transparent",
                                    border: "none",
                                    color: "#5e84ca",
                                    textDecoration: "underline",
                                    cursor: timeLeft > 0 ? "not-allowed" : "pointer",
                                    fontWeight: "normal",
                                    opacity: timeLeft > 0 ? 0.5 : 1,
                                    textUnderlinePosition: "under"
                                }}
                                disabled={timeLeft > 0}
                                onClick={() => {
                                    if (timeLeft === 0) {
                                        this.resendVerificationCode()
                                    }
                                }}
                            >
                                <span style={{ textDecoration: "none" }}>
                                    {T.t("r_add_two_factor_code_resend")}
                                </span>
                                {timeLeft > 0 && (
                                    <span>
                                        &nbsp;({this.formatTime(timeLeft)})
                                    </span>
                                )}
                            </button>
                        </div>
                    }
                    <div></div>

                    <div className="social-footer" style={{ marginTop: "60px" }}>
                        <div className="activity-footer d-flex justify-content-between">
                            <div className="mini-btn">
                                {/* tslint:disable-next-line */}
                                <button onClick={() => this.props.onClickTwofactorModel(false)} type="button" className="btn btn-gray min-auto">{T.t('r_cancel_button')}</button>
                            </div>
                            <div className="mini-btn text-md-right">
                                {/* tslint:disable-next-line */}
                                <button disabled={!this.state.isVerificationCodeConfirmed} onClick={() => { this.checkVerificationCode() }} type="button" className="btn btn-green min-auto"> {T.t('r_save_button')}</button>
                            </div>
                        </div>
                    </div>
                </div>


            </Modal>
        );
    }
}


export default TwoFactorMail;
